import { useEffect, ReactNode } from 'react';
import { Grid, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useLogin from 'hooks/useLogin';
import isEmpty from 'lodash/isEmpty';
import { useProject } from 'hooks/useProject';
import LoginWrapper from './LoginWrapper';

interface ILoginContainerProps {
  value: string;
  component: ReactNode;
}
function LoginContainer({ value, component }: ILoginContainerProps): JSX.Element {
  const navigate = useNavigate();
  const { info } = useLogin();
  const { accessToken } = info;
  const { getAdminAccountProfile } = useProject();
  const { data, isLoading } = getAdminAccountProfile();

  useEffect(() => {
    if (value === 'Sign Up') {
      return;
    }
    if (isEmpty(accessToken)) {
      navigate('/login');
    } else if (!isLoading) {
      if (data?.roles?.some(obj => obj.id === 10)) {
        navigate('/admin/project/overview');
      } else {
        navigate('/manager/member-management');
      }
    }
  }, [accessToken, data?.roles, isLoading, navigate, value]);

  return (
    <LoginWrapper>
      <Grid container>
        <Grid item xs={12}>
          <Stack spacing={1} direction="column" justifyContent="center" alignItems="flex-start" sx={{ mb: { xs: 3 } }}>
            <Typography variant="h1" sx={{ fontWeight: 800, fontSize: '2rem' }}>
              {value}
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          {component}
        </Grid>
      </Grid>
    </LoginWrapper>
  );
}

export default LoginContainer;
